import React, { useState } from 'react'
import classNames from 'classnames'
import { flowRight } from 'lodash'
import { withTranslationCustom } from 'lib/i18next'

import FormElementErrorMessage from './FormElementErrorMessage'
import Button from 'components/UI/Button'
import Icon from 'components/Icon'

const FormElement = (
    {
        t,
        children,
        elementClass,
        error,
        description,
        tip,
        label,
        loading,
        validating,
        disabled,
        required,
        value,
        isStatic,
        inlineDescription,
        strongLabel,
        editDisplayButton,
        editOnClick,
        editTrackName,
        size,
        additionalDetailsButton,
        additionalDetailsButtonText,
        cancelEditButton,
        onCancelEditClick,
        hideErrorMessage,
        ...rest
    }
) => {
    const { name } = rest

    const [showAdditionalDetails, setShowAdditionalDetails] = useState(false)

    const additionalDetailsText = additionalDetailsButtonText || (
        additionalDetailsButtonText !== false ? t('common:additionalDetails') : null
    )

    return (
        <div
            className={classNames(
                'form-element',
                `form-element--name-${name}`,
                size ? `form-element--size-${size}` : '',
                elementClass || 'form-element--input',
                { 'form-element--required': required },
                { 'form-element--disabled': disabled },
                { 'form-element--invalid': error },
                { 'form-element--static': isStatic },
                { 'form-element--loading': !!loading },
                { 'form-element--validating': !!validating },
                { 'form-element--empty': (!value && value !== 0) },
                { 'form-element--inline-description': inlineDescription },
                { 'form-element--strong-label': strongLabel },
            )}
        >
            {(label || description) && (
                <div className="label-and-description">
                    {label && <label>{label}{required && <sup>*</sup>}</label>}
                    {(description && !additionalDetailsButton) && <p className="form-element__description">{description}</p>}
                    {(additionalDetailsButton) && (
                        <Button
                            type="button"
                            className="form-element__additional-details"
                            trackName="showDetails"
                            onClick={() => setShowAdditionalDetails(!showAdditionalDetails)}
                        >
                            {additionalDetailsText && <span>{additionalDetailsText}</span>}
                            <Icon name="icon_info_circle" size="m" />
                        </Button>
                    )}
                    {showAdditionalDetails && (
                        <div className="form-element__description">{description}</div>
                    )}
                </div>
            )}
            {(error && !hideErrorMessage) && (
                <div className="error">
                    <FormElementErrorMessage message={error} />
                </div>
            )}
            {isStatic ? (
                <div className="form-element--static__value" id={name}>
                    {value}
                    {editDisplayButton && (
                        <div className="form-element__edit-button">
                            <Button
                                type="button"
                                className="button button--tertiary"
                                onClick={(e) => editOnClick(e)}
                                trackName={editTrackName}
                            >
                                {t('common:edit')}
                            </Button>
                        </div>
                    )}
                </div>
            ) : (
                <div
                    className={classNames(
                        'form-element__field-container',
                        { 'form-element__content': cancelEditButton }
                    )}
                >
                    {children(rest)}
                    {cancelEditButton && (
                        <div className="form-element__cancel-edit-button">
                            <Button
                                type="button"
                                className="button button--tertiary"
                                onClick={(e) => onCancelEditClick(e)}
                                trackName="cancelEdit"
                            >
                                {t('common:cancel')}
                            </Button>
                        </div>
                    )}
                </div>
            )}
            {tip && (
                <div className="form-element__tip">
                    {tip}
                </div>
            )}
        </div>
    )
}

export default flowRight(
    withTranslationCustom('common')
)(FormElement)
